import { render, staticRenderFns } from "./ejemplos_ws_en.vue?vue&type=template&id=22a695c3&scoped=true&"
import script from "./ejemplos_ws_en.vue?vue&type=script&lang=js&"
export * from "./ejemplos_ws_en.vue?vue&type=script&lang=js&"
import style0 from "./ejemplos_ws_en.vue?vue&type=style&index=0&id=22a695c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a695c3",
  null
  
)

export default component.exports